import * as fields   from './fields'
import * as messages from './messages'

export function serializeForm (form, context = '')
{
	const rgpd = form.querySelector('input[name="rgpd"]')
	const formFields = [...form.elements]
		.filter(el => (el.type !== 'submit' && el.name !== 'rgpd'))
	
	if (context !== 'inline')
	{
		for (let el of [...formFields])
		{
			const validate = fields.validate(el, el.value)
			const field = el.closest('.field')
			
			if (validate.error)
			{
				if (field)
				{
					field.classList.add('error')
				}
				
				return {
					error: true,
					message: validate.message,
					form: form
				}
			}
			else
			{
				if (field)
				{
					field.classList.remove('error')
				}
			}
		}
	}
	
	if (rgpd && !rgpd.checked)
	{
		return {
			error: true,
			message: 'L\'envoi du formulaire nécessite votre consentement'
		}
	}
	
	return [...form.elements]
		.filter(el => el.type !== 'submit' && ((el.type !== 'checkbox' && el.type !== 'radio') || ((el.type === 'checkbox' || el.type === 'radio') && el.checked)))
		.map(el => el.name + '=' + encodeURIComponent(el.value))
		.join('&')
}

export async function req (form, url, data, context = '')
{
	form.classList.add('processing')
	fields.disable(form)
	
	return await fetch(url, {
		method: 'POST',
		body: data,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
			'X-Requested-With': 'XMLHttpRequest'
		}
	}).then((response) =>
	{
		return response.ok ? response.json() : Promise.reject(response.statusText)
	}).then((response) =>
	{
		if (response.success)
		{
			form.classList.add('processed')
		}
		
		if (context !== 'inline')
		{
			messages.add(response.success, response.data.message, form)
		}
		
		form.classList.remove('processing')
		fields.disable(form, response.success)
		
		return response
	}).catch((error) =>
	{
		if (context !== 'inline')
		{
			messages.add(false, error, form)
		}
		
		form.classList.remove('processing')
		fields.disable(form, false)
	})
}
